import { convertToLocalStyle, getColumnSolidBorderStyle } from '@bingads-webui-campaign-react/common-styles';
import { getTableStyles, getTableGlobalStyles } from '@bingads-webui-campaign-react/grid-view-wrapper';
import { merge } from '@bingads-webui/primitive-utilities';

export const getFeedUploadStyles = (_, { palette = {} }) => ({
  '@global': {
    '.bingads-campaign-react-sub-page-menu': {
      '& .compared-date-range-picker': {
        display: 'none',
      },
    },
  },
  FeedUpload: merge({
    marginLeft: '32px',
    marginTop: '32px',
    display: 'flex',
    overflow: 'auto',
    flex: '1 0 1px',
    flexDirection: 'column',

    '& .intelligence-feed-upload-container': {
      '& .disabled': {
        pointerEvents: 'none',
      },

      '& .form-group': {
        marginRight: 0,
      },

      '& .form-group:nth-child(1)': {
        display: 'none',
      },

      '& .form-group:nth-child(2)': {
        lineHeight: '19px',
        marginBottom: '52px',
      },

      '& .form-group:nth-child(3)': {
        marginBottom: 8,
        '& .col-sm-1': {
          width: 'auto',
        },
        '& .col-sm-2.type-bold': {
          padding: 0,
        },
      },

      '& .form-group:nth-child(4)': {
        '& .col-sm-4': {
          paddingRight: 8,
          '& .file-picker': {
            '& .file-text': {
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              display: 'inherit',
            },
          },
        },
        '& .col-sm-2': {
          padding: 0,
          '& .btn': {
            lineHeight: '32px',
          },
        },
      },

      '& .form-group:nth-child(5)': {
        marginTop: '20px',
      },
      '& .table-bordered': {
        border: 0,
      },
    },
    '& .feed-upload-grid': getTableStyles(_, { palette }),
    ...getColumnSolidBorderStyle(0, 2),
  }, convertToLocalStyle(getTableGlobalStyles(_, { palette }))),
});
